import type { ErrorResponse } from "@apollo/client/link/error";

import { LOG_APPLICATION_ERROR, RESET_GLOBAL_ERROR, SET_GLOBAL_ERROR } from "../action-types.js";
import type { IAppState } from "../reducer.js";

/**
 * State definition
 */
export interface IErrorsState {
  errorsList: IStampedError[];
  fetchError: IFetchError;
}

export interface IStampedError {
  date: string;
  error: any;
  type?: string;
}

export interface IFetchError {
  type: string;
  message: string;
}

const initialState: IErrorsState = {
  errorsList: [],
  fetchError: null,
};

/**
 * Reducers
 */
export default function errorsReducer(state: IErrorsState = initialState, action) {
  const { error, type, payload } = action;

  if (type === LOG_APPLICATION_ERROR) {
    const stampedError: IStampedError = {
      error: error,
      date: new Date().toISOString(),
      type: type,
    };

    const updatedErrorsList = state.errorsList.splice(0);
    updatedErrorsList.unshift(stampedError);
    return {
      ...state,
      errorsList: updatedErrorsList,
    };
  }
  if (type === SET_GLOBAL_ERROR) {
    return {
      ...state,
      fetchError: payload,
    };
  }
  if (type === RESET_GLOBAL_ERROR) {
    return {
      ...state,
      fetchError: null,
    };
  }

  return state;
}

/**
 * Action creators
 */
export function logApplicationError(error: Error | ErrorResponse) {
  return (dispatch) => {
    if (error) {
      dispatch({
        type: LOG_APPLICATION_ERROR,
        error: error,
      });
    }
  };
}

export function showErrorPage(errorType: string, errorMessage: string, error?: Error) {
  return (dispatch, _getState: () => IAppState) => {
    if (error) {
      dispatch(logApplicationError(error));
    }
    // will change the state and trigger the display of the error page
    dispatch({
      type: SET_GLOBAL_ERROR,
      payload: {
        type: errorType,
        message: errorMessage,
      },
    });
  };
}

export function resetFetchError() {
  return { type: RESET_GLOBAL_ERROR };
}

// for general error reporting, see data-export.ts / downloadLogArchive()
// on dev mode you might encounter "Script error" because of  https://stackoverflow.com/questions/5913978/cryptic-script-error-reported-in-javascript-in-chrome-and-firefox
export const loggedErrors: any[] = [];
window.onerror = (message, url, _lineno, _colno, error) => {
  loggedErrors.push({ message, url, error });
  return false; //returning true will prevent the firing of the default handler,
};
